import {
  usePropertyServicePropertyBuildingConstructionsTypesListKey,
  usePropertyServicePropertyBuildingDestinationsListKey,
  usePropertyServicePropertyBuildingProtectionsListKey
} from '@insurance/api/queries'
import { PropertyService } from '@insurance/api/requests'
import { InfiniteSelect, InputParsedNumber } from '@shared/components'
import { Col, Form, Input, Row } from 'antd'

import { useTranslation } from 'react-i18next'

import { usePropertyInsuranceValues } from './PropertyInsuranceContext'

type Props = {
  fieldKey: number
}

export const ItemCategoryAFields = ({ fieldKey }: Props) => {
  const { t } = useTranslation()
  const { isEditable } = usePropertyInsuranceValues()

  return (
    <Row gutter={[12, 12]}>
      <Col xs={24} md={12}>
        <Form.Item
          label={t('year_of_production')}
          name={[fieldKey, 'a', 'year']}
        >
          <InputParsedNumber
            min={0}
            placeholder={t('year_of_production')}
            className="w-full"
            disabled={isEditable}
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item name={[fieldKey, 'a', 'area']} label={t('area')}>
          <InputParsedNumber
            min={0}
            placeholder={t('area')}
            className="w-full"
            suffix={t('area_m2')}
            disabled={isEditable}
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item name={[fieldKey, 'a', 'floors']} label={t('floors')}>
          <InputParsedNumber
            min={0}
            placeholder={t('floors')}
            className="w-full"
            disabled={isEditable}
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item
          name={[fieldKey, 'a', 'destination']}
          label={t('destination')}
        >
          <InfiniteSelect
            placeholder={t('destination')}
            className="w-full"
            apiCall={({ search, pageParam, pageSize }) =>
              PropertyService.propertyBuildingDestinationsList(
                undefined,
                pageParam,
                pageSize,
                search
              )
            }
            queryKey={[usePropertyServicePropertyBuildingDestinationsListKey]}
            getOption={(item) => ({
              value: item.code,
              label: item.name
            })}
            disabled={isEditable}
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item
          name={[fieldKey, 'a', 'cadastral_number']}
          label={t('cadastral_number')}
        >
          <Input
            placeholder={t('cadastral_number')}
            className="w-full"
            disabled={isEditable}
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item
          name={[fieldKey, 'a', 'construction']}
          label={t('construction')}
        >
          <InfiniteSelect
            placeholder={t('construction')}
            className="w-full"
            apiCall={({ search, pageParam, pageSize }) =>
              PropertyService.propertyBuildingConstructionsTypesList(
                undefined,
                pageParam,
                pageSize,
                search
              )
            }
            queryKey={[
              usePropertyServicePropertyBuildingConstructionsTypesListKey
            ]}
            getOption={(item) => ({
              value: item.code,
              label: item.name
            })}
            disabled={isEditable}
          />
        </Form.Item>
      </Col>

      <Col xs={24}>
        <Form.Item
          name={[fieldKey, 'a', 'protections']}
          label={t('building_protection')}
        >
          <InfiniteSelect
            placeholder={t('building_protection')}
            className="w-full"
            mode="multiple"
            maxTagCount={3}
            apiCall={({ search, pageParam, pageSize }) =>
              PropertyService.propertyBuildingProtectionsList(
                undefined,
                pageParam,
                pageSize,
                search
              )
            }
            queryKey={[usePropertyServicePropertyBuildingProtectionsListKey]}
            getOption={(item) => ({
              value: item.code,
              label: item.name
            })}
            disabled={isEditable}
          />
        </Form.Item>
      </Col>
    </Row>
  )
}
